<template>
  <Modal :title="$t('messageHistory')" @close-modal="$emit('close-modal', false)">
    <div v-for="message in messages" :key="message.id" class="message">
      {{ message.settedTime }} – {{ message.message }}
    </div>
  </Modal>
</template>

<script>
import Modal from "@/components/Modal"

export default {
  name: "MessagesModal",

  components: {
    Modal,
  },

  props: {
    messages: Array,
  },
}
</script>

<style lang="scss" scoped>
.message {
  background: #fff;
  padding: 2rem;
  margin: 1rem;

  &:not(:last-child) {
    margin-bottom: 1rem;
  }
}
</style>
